import { JoinBroadcastLinkType } from '~/helpers/enums';

export default {
  broadcast: null,
  pending: true,
  error: null,
  linkType: JoinBroadcastLinkType.BROADCAST,
};
